import React from 'react';
import BillingPortalLink from './BillingPortalLink';
import type { CoreStripePaymentNotice } from './planSelectorPaymentNotice';

interface PlanSelectorPaymentPresentationProps {
  notice: CoreStripePaymentNotice | null;
  isShopifyBilling: boolean;
  showNotice: boolean;
  showPortal: boolean;
  portalDisabled: boolean;
  onPortalClick: () => void;
  translate: (key: string) => string;
}

export const shouldDisableCoreStripePlanAction = ({
  notice,
  isCurrentPlan: _isCurrentPlan,
  isCurrentCycle: _isCurrentCycle,
}: {
  notice: CoreStripePaymentNotice | null;
  isCurrentPlan: boolean;
  isCurrentCycle: boolean;
}) => Boolean(notice);

export const PlanSelectorPaymentPresentation: React.FC<PlanSelectorPaymentPresentationProps> = ({
  notice,
  isShopifyBilling,
  showNotice,
  showPortal,
  portalDisabled,
  onPortalClick,
  translate,
}) => {
  const portalLabel = isShopifyBilling
    ? translate('website.pricing.cancelSubscription')
    : translate(notice?.portalActionKey || 'website.pricing.editBilling');

  return (
    <>
      {showNotice && notice ? (
        <div
          role="status"
          className="mx-auto mb-5 w-full max-w-[820px] rounded-[16px] border border-amber-200 bg-amber-50 px-5 py-4 text-left"
        >
          <p className="text-sm font-semibold text-[#7C4A03]">{translate(notice.titleKey)}</p>
          <p className="mt-1 text-sm text-[#7C4A03]">{translate(notice.descriptionKey)}</p>
        </div>
      ) : null}
      {showPortal ? (
        <BillingPortalLink label={portalLabel} onClick={onPortalClick} disabled={portalDisabled} />
      ) : null}
    </>
  );
};
